<template>
  <div>
    <div v-for="section in sections" :key="section.name">
      <h2 class="section-title">
        {{ $t(section.name) }}
      </h2>
      <van-cell-group>
        <van-cell
          v-for="(configuration, index) in section.configurations"
          :key="configuration.text"
          :title="$t(configuration.text)"
        >
          <template #title>
            <span class="center-setting">
              {{ $t(configuration.text) }}
              <van-icon
                name="question-o"
                v-if="configuration.hint"
                @click="showHint(index)"
              />
            </span>
          </template>
          <template #right-icon>
            <Setting :configuration="configuration" />
          </template>
          <template #label v-if="configuration.hint && showIndex == index">
            {{ $t(configuration.hint) }}
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Setting from "@/components/Setting";
export default {
  name: "Settings",
  components: { Setting },
  data() {
    return {
      showIndex: null
    };
  },
  computed: {
    ...mapState("setting", ["sections"])
  },
  methods: {
    showHint(index) {
      if (this.showIndex == index) {
        this.showIndex = null;
      } else {
        this.showIndex = index;
      }
    }
  }
};
</script>

<style lang="scss">
.center-setting {
  display: flex;
  align-items: center;
}

.van-cell {
  display: flex;
  align-items: center;
}
</style>
